import {EnumLanguage} from "../EnumLanguage";

export const UXAbout = {
    description: {
        [EnumLanguage.en]: 'MIS is designed to computerize and systematize the accounting, storage, scientific and exposition activities of the museum.',
        [EnumLanguage.ru]: 'МИС предназначена для компьютеризации и систематизации учетно-хранительской, научной и экспозиционной деятельности музея.',
        [EnumLanguage.cn]: 'MIS 旨在使博物馆的会计、存储、科学和展览活动计算机化和系统化。'
    }
}